import { Features, isFeatureEnabled } from '../../featureToggles/features';
import { getTextWidth } from './string.utils';

const PADDING = isFeatureEnabled(Features.panel2) ? 70 : 64;
const FONT = isFeatureEnabled(Features.panel2) ? '16px arial' : '14px arial';
export const getMaxLanguageWidth = (languages = []) => {
  let maxLanguageWidth = 0;
  languages.forEach((language) => {
    const textLength = Math.ceil(getTextWidth(language.text, FONT));
    maxLanguageWidth = textLength > maxLanguageWidth ? textLength : maxLanguageWidth;
  });
  return maxLanguageWidth + PADDING;
};
